import type {
  SearchFiltersSchema,
  SearchFiltersSchemaCertificationStatus,
} from "@/lib/api/model";

/**
 * Run degraded reason the backend adds when a non-`any` certification status
 * could not be applied because the profile index predates the nested
 * `certifications` field (schema < 3); the name/vendor chips still applied.
 */
export const CERTIFICATION_STATUS_UNAVAILABLE = "certification_status_unavailable";

export const CERTIFICATION_STATUS_OPTIONS: {
  value: SearchFiltersSchemaCertificationStatus;
  label: string;
  help: string | null;
}[] = [
  { value: "any", label: "Any", help: null },
  {
    value: "not_expired",
    label: "Not expired",
    help: "Not expired includes certifications without an expiration date",
  },
  {
    value: "verified_current",
    label: "Verified current",
    help: "Verified current requires an expiration date in the future",
  },
];

/** Active certification inputs: every chip, plus the status when it narrows. */
export function countCertificationFilters(f: SearchFiltersSchema): number {
  return (
    (f.certification_names?.length ?? 0) +
    (f.certification_vendors?.length ?? 0) +
    ((f.certification_status ?? "any") !== "any" ? 1 : 0)
  );
}
